import React, { Component, Fragment } from "react";
import { Form, Input, Table, Modal, Radio, Spin } from "antd";
import Api from "../../../services/ServiceApi";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";

class Employee extends Component {
  employeeRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [],
      master_data: [],
      visible: false,
      title: "Employee",
      columns: [
        {
          title: "Employee ID",
          key: "emp_id",
          render: (item) =>
            !item.emp_id ? (
              "-"
            ) : (
              <Link to="/full_detail_job" className="c-blue text-underline">
                {item.emp_id}
              </Link>
            ),
          align: "center",
          sorter: (a, b) => 
          (a.emp_id === null || a.emp_id  === undefined ? 0 : a.emp_id) -  
          (b.emp_id === null || b.emp_id  === undefined ? 0 : b.emp_id),
        },
        {
          title: "Employee Name",
          render: (item) => (!item.emp_name ? null : item.emp_name),
          align: "center",
          key: "emp_name",
          sorter: (a, b) => 
          (a.emp_name === null || a.emp_name  === undefined ? "" : a.emp_name).localeCompare  
          (b.emp_name === null || b.emp_name  === undefined ? "" : b.emp_name),
        },
        {
          title: "Department",
          dataIndex: "department_name",
          align: "center",
          key: "department_id",
          sorter: (a, b) => 
          (a.department_name === null || a.department_name  === undefined ? "" : a.department_name) -  
          (b.department_name === null || b.department_name  === undefined ? "" : b.department_name),        
        },
        {
          title: "Division",
          dataIndex: "division_name",
          align: "center",
          key: "division_name",
          sorter: (a, b) => 
          (a.division_name === null || a.division_name  === undefined ? "" : a.division_name) -  
          (b.division_name === null || b.division_name  === undefined ? "" : b.division_name),         
        },
        {
          title: "Skill",
          dataIndex: "emp_skill_list",
          align: "center",
          key: "emp_skill",
          sorter: (a, b) => 
          (a.emp_skill_list === null || a.emp_skill_list  === undefined ? "" : a.emp_skill).localeCompare 
          (b.emp_skill_list === null || b.emp_skill_list  === undefined ? "" : b.emp_skill),  
        },
        {
          title: "Status",
          dataIndex: "status",
          align: "center",
          key: "status",
          sorter: (a, b) => 
          (a.status === null || a.status  === undefined ? 0 : a.status) - 
          (b.status === null || b.status  === undefined ? 0 : b.status),          
          render: (item) => (
            <div>
              {item === 0 ? (
                <span></span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
        },
        {
          title: "Action",
          align: "center",
          render: (item) => (
            <div>
              {/* <Link to="/full_detail_job"> */}
                {/* <img src={Api.absoluteUrl("/icon/view.svg")} width="35" /> */}
              {/* </Link> */}
              {/* <Link to="/edit_job"> */}
                <img src={Api.absoluteUrl("/icon/edit.svg")} style={{cursor: "pointer"}} onClick={() => this.onModal(true, "edit", item)} alt="edit-ic" />
              {/* </Link> */}
              {/* <Link to="/delete"> */}
                <img src={Api.absoluteUrl("/icon/delete.svg")} style={{cursor: "pointer"}} onClick={() => this.onModal(true, "delete", item)} alt="delete-ic"  />
              {/* </Link> */}
            </div>
          ),
        },
      ],
      mode: "",
      visible_delete: false,
      loading_modal_delete: false,
      modal_item: null,
    };
  }

  async componentDidMount() {
    const result = await Api.post("/v2/get_employee", {
      "pk_id":null,
      "is_active":1,
      "sql_where":" and t.company_id=1",
      "company_id": Cookies.get("companyid"),
      "operator_id": Cookies.get("operator_id"),
      "project_id": Cookies.get("project_id")
    });
    if (result.data.result.code === "P") {
      this.setState({
        data: result.data.data,
        master_data: result.data.data,
        loading: false,
      });
    } 
  }

  handleSubmit(values) {
    const {mode} = this.state;
    if(mode === "add"){
        // TO DO
    } else if (mode === "edit"){
        // TO DO
    }
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  async onModal(visible, mode, data) {
    if(mode === "add"){
      this.setState({ 
        mode: mode,
        visible: visible,
      });
    } else if (mode === "delete") {
      this.setState({ 
        mode: mode,
        visible_delete: visible,      
      });
    } else if (mode === "edit") {
      console.log(data);
      this.setState({ 
        modal_item: data,
        mode: mode,
        visible: visible,
        value: data.is_active
      });
    } else {
      this.setState({ 
        visible: visible,
        visible_delete: visible,
        modal_item: false,
        mode: "",
        value: 1,
      });
    }
  }


  Search = async  (value) => {
    console.log(value);
    const {master_data} = this.state;
    await this.setState({
      data: [],
    })
    if(value != undefined){
      var setdata = [];
      var obj = {};
          for (let i = 0; i < master_data.length; i++) {
              for (const [key, value] of Object.entries(master_data[i])) {
                  if (value == null || value == undefined) {
                  obj[`${key}`] = "-"
                  } else {
                  obj[`${key}`] = `${value}`
                  }
              }
              setdata.push(obj);
              obj = {};
          }        
      const filter_table = setdata.filter((o) =>
      Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase().trim())
      )
      );

      this.setState({
          data: filter_table
      })
    } else {
      this.setState({
        data: master_data
    })
    }
  }

  renderEmployee() {
    const { visible, value, mode, modal_item } = this.state;
    return (
      <Modal
        title={<span className="font-mont-b fs-16 c-blue">{mode.toUpperCase()} EMPLOYEE</span>}
        centered
        visible={visible}
        footer={null}
        closable={false}
        className="custom-modal"
        destroyOnClose={true}
      >
          {mode === "edit" ?
         <div className="d-flex align-items-center"> 
          <div className="mr-4">
            <span className="font-thai-r fs-18">Status</span>
          </div>
          <Radio.Group onChange={this.onChange} defaultValue={value}>
            <Radio value={1}>
              <span className="font-thai-r fs-18">Active</span>
            </Radio>
            <Radio value={2}>
              <span className="font-thai-r fs-18">Inactive</span>
            </Radio>
          </Radio.Group>
        </div>
        : null }
        <Form
          onFinish={(values) => this.handleSubmit(values)}
          layout="vertical"
          ref={this.employeeRef}
          initialValues={{
            employee_name: modal_item != null ? modal_item.emp_name : null,
            employee_nickname: modal_item != null ? modal_item.emp_nickname : null,
            head_employee: modal_item != null ? modal_item.head_emp_id : null,
            skill:  modal_item != null ? modal_item.emp_skill : null,
            department: modal_item != null ? modal_item.division_id : null,
            division: modal_item != null ? modal_item.division : null,
            tel: modal_item != null ? modal_item.tel : null,
            email: modal_item != null ? modal_item.email : null,
            address: modal_item != null ? modal_item.address : null,
          }}
        >
          <div className="row">
                {/* <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Employee ID"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div> */}
                <div className="col-6">
                  <Form.Item
                    name="employee_name"
                    label="Employee Name"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>
                <div className="col-6">
                  <Form.Item
                    name="employee_nickname"
                    label="Employee Nick name"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>
                <div className="col-6">
                  <Form.Item
                    name="head_employee"
                    label="Head Employee"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>
                <div className="col-6">
                  <Form.Item
                    name="skill"
                    label="Skill"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Enter skill name"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>
                <div className="col-6">
                  <Form.Item
                    name="department"
                    label="Department"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Enter department name"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>
                <div className="col-6">
                  <Form.Item
                    name="division"
                    label="Division"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Enter division name"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>
                <div className="col-6">
                  <Form.Item
                    name="tel"
                    label="Tel"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="number"
                      size="large"
                      placeholder="Please Input"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>
                <div className="col-6">
                  <Form.Item
                    name="email"
                    label="E-mail"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                      style={{width: "100%", maxWidth: "100%"}}
                    />
                  </Form.Item>
                </div>

                <div className="col-12">
                    <Form.Item
                          name="address"
                          label={<div className="font-mont-m fs-12">Reason</div>}
                          rules={[
                            {
                              required: true,
                              message: "โปรดเขียนรายละเอียด",
                            },
                          ]}
                        >
                          <Input.TextArea rows={4} placeholder="Please Input" />
                    </Form.Item>
                </div>
            {/* <div className="col-3">
              <Form.Item
                name="fullname"
                label="Profile Picture"
                rules={[{ required: true, message: "Full name is required" }]}
              ></Form.Item>
            </div> */}
          </div>

          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.onModal(false, "")}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success" type="submit">Add</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderDelete() {
    const { loading_modal_delete, visible_delete, modal_item } = this.state;
    // Add Material Form
    return (
      <Fragment>
        <Modal
          title={"Delete Employee"}
          centered={true}
          visible={visible_delete}
          footer={false}
          destroyOnClose={true}
          onCancel={this.ModalClosed}
        >
          <Spin spinning={loading_modal_delete}>

            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  Are you sure?
                </span>
              </div>
            </div>

            <div
              style={{
                fontFamily: "MontserratM",
                fontWeight: "bold",
                color: "#0500A3",
              }}
            >
              <div>
                <div className="row">
                  <div className="col text-center justify-content-between">
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.setState({ visible_delete: false })}
                      className="btn btn-secondary"
                    >
                      No
                    </button>
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.handleDelete()}
                      className="btn btn-danger"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* </Form> */}
          </Spin>
        </Modal>
      </Fragment>
    );
  }

  handleDelete(){
  }

  render() {
    const { title, data, columns, visible } = this.state;
    return (
      <div>
        {this.renderDelete()}
        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">{title}</h3>
        <div className="d-flex justify-content-between my-3">
          <Input.Search
            placeholder="Search"
            onSearch={this.Search}
            allowClear
            style={{ width: 200 }}
          />
          <button
            className="btn btn-warning"
            onClick={() => this.onModal(true, "add", null)}
          >
            <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
            Add {title}
          </button>
        </div>
        <Table rowKey="emp_id" columns={columns} dataSource={data} />
        {visible? this.renderEmployee(): null}
      </div>
    );
  }
}

export default Employee;
